export default __webpack_public_path__ + "app/images/d1a51d19176b235a350a0815519f8c48.png";